export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      "J'avais peur du coréen. Tous ces symboles me semblaient impossibles. Après le jour 5 avec Coréen Express, j'ai pu lire ma première phrase en Hangeul sans aide. À la semaine 3, je regardais des K-Dramas et je comprenais les mots réels. Ce système a complètement changé ma vie.",
    name: 'Marie D.',
    location: 'Paris · France',
    flag: '🇫🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/362d210d-32c8-42e9-94ff-bc4f4952fd79.jpg',
  },
  {
    quote:
      "Je regardais des K-Dramas depuis 2 ans en étant frustré parce que je ne comprenais RIEN. J'ai essayé une app pendant 6 mois sans vrai progrès. La méthode Coréen Express fonctionne réellement. Je suis maintenant dans la communauté Discord en train de parler avec des Coréens authentiques.",
    name: 'Antoine L.',
    location: 'Lyon · France',
    flag: '🇫🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/80848e14-15f4-430a-9b92-68ab90c6b61e.jpg',
  },
  {
    quote:
      "J'avais peur de ne pas être « douée pour les langues ». Coréen Express m'a prouvé le contraire. La méthode visuelle rend tout si clair. J'ai senti du progrès DÈS LE JOUR UN, ce qui m'a motivée. Je la recommande à tous les fans de K-Pop que je connais.",
    name: 'Sophie B.',
    location: 'Marseille · France',
    flag: '🇫🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/880ec9f6-323a-450b-80d1-71b8a76c1a33.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'Les flashcards vivent maintenant sur mon téléphone. Je révise le Hangeul dans le bus et je lis déjà les menus et les panneaux dans les K-Dramas avant que les sous-titres n’apparaissent.',
    name: 'Léa M.',
    location: 'Toulouse · France',
    flag: '🇫🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7403b0e6-4b72-48c1-9192-410f031e00ab.jpg',
  },
  {
    quote:
      'Hangeul Express l’a fait en deux soirées. J’avais essayé trois fois auparavant avec des vidéos et j’ai toujours abandonné. Voir les blocs de syllabes expliqués visuellement a finalement fait clic.',
    name: 'Thomas R.',
    location: 'Bordeaux · France',
    flag: '🇫🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/81425cb1-d010-4002-b9db-3ff420402612.jpg',
  },
  {
    quote:
      'Le calendrier de 60 minutes est ce qui m’a maintenu cohérent. 60 minutes par jour, pas de doute sur ce qu’il faut étudier. Le jour 55, j’ai envoyé mon premier message en coréen à un ami à Séoul.',
    name: 'Julien P.',
    location: 'Nice · France',
    flag: '🇫🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/47b0264e-cbb6-45c9-bff8-6a1a4a2fd195.jpg',
  },
  {
    quote:
      "Je l'ai acheté pour les paroles de K-Pop ; j'ai rencontré des locuteurs natifs, échangé des idées et partagé nos cultures. Cela vaut bien plus que 27 €.",
    name: 'Camille Z.',
    location: 'Strasbourg · France',
    flag: '🇫🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/fe614a6f-eaed-43fd-ab74-bd42110ca59c.jpg',
  },
];
